<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center" :style="{height:Height+'px'}">
        <img :src="pageLoader_img">
        <p>{{Message}}</p>
    </div>
</template>
<script>
export default {
    props: ['Message', 'Height']
}
</script>


// WEBPACK FOOTER //
// MessageLoader.vue?aa7347d0